<script setup>
import { onMounted, ref } from "vue";
import {deviceList, groupDeviceList} from "@/api/device";
import { groupPage } from "@/api/group";

const activeNames = ref([]);
const groupList = ref([]);
const newGroupList = ref([]);
const deviceListData = ref([]);

// 折叠面板的 change 事件处理函数
const handleChange = (val) => {
  console.log(val);
};

// 获取组列表
const getGroupList = () => {
  groupPage({}).then((res) => {
    if (res?.data?.list) {
      groupList.value = res.data.list;

      getDeviceList();
      getGroupDevice();
      // if(groupList.value && groupList.value.length === 0){
      //   // 无组的情况下，获取100条设备数据
      //   getDeviceList()
      // } else {
      //   // 为每个组查询组下的设备列表
      //   getGroupDevice();
      // }


    }
  });
};

// 获取并处理组下设备列表
const getGroupDevice = async () => {
  newGroupList.value = await Promise.all(
      groupList.value.map(async (item) => {
        const deviceList = await groupDeviceList({ groupId: item.id });
        if (deviceList?.data) {
          deviceList.data = deviceList.data.map((device) => ({
            ...device,
            checked: false,
          }));
        }
        return {
          ...item,
          deviceList,
        };
      })
  );
  console.log("= 获取组下设备", newGroupList.value);
};

// 处理设备选中状态并传递给父组件
const checkDevice = () => {
  console.log("= 设备方法", newGroupList.value);

  let checkedIds = []
  // 组不为空的情况下
  // if(newGroupList.value && newGroupList.value.length > 0){
  //   // 获取所有 checked 为 true 的设备的 id
  //   checkedIds = newGroupList.value.flatMap((group) =>
  //       group.deviceList.data
  //           .filter((device) => device.checked)
  //           .map((device) => device.deviceName)
  //   );
  //   console.log("= checkedIds", checkedIds);
  //   emit("deviceList", checkedIds);
  // }

  // 没有组的情况下，
  // 获取所有 checked 为 true 的设备的 id
  checkedIds = deviceListData.value.filter((device) => device.checked)
      .map((device) => device.deviceName)

  console.log("= checkedIds", checkedIds);
  emit("deviceList", checkedIds);
  // if(newGroupList.value && newGroupList.value.length === 0){
  //   // 获取所有 checked 为 true 的设备的 id
  //   const checkedIds = deviceListData.value.filter((device) => device.checked)
  //           .map((device) => device.deviceName)
  //
  //   console.log("= checkedIds", checkedIds);
  //   emit("deviceList", checkedIds);
  // }

};

// 获取默认组的100条数据
// 获取设备列表
const getDeviceList = (params) => {
  deviceList(params).then(res => {
    if(res && res.data && res.data.list){
      deviceListData.value = res.data.list
    }
  })
}

// 定义 emit 事件
const emit = defineEmits(["deviceList"]);

// 组件挂载时调用 getGroupList 函数
onMounted(() => {
  getGroupList();
});
</script>

<template>
  <el-collapse v-model="activeNames" @change="handleChange">
    <div>
<!--      <div v-if="newGroupList && newGroupList.length === 0">-->
      <el-collapse-item :title="$t('group.defaultGroup')" >
        <div v-if="deviceListData && deviceListData.length > 0">

          <div
              v-for="(it, idx) in deviceListData"
              :key="idx"
              class="device-item p-3 d-flex align-items-center justify-content-between"
          >
            <div>{{ it.noteName }}</div>
            <div>
              <el-checkbox
                  v-model="it.checked"
                  size="large"
                  @change="checkDevice"
              />
            </div>
          </div>

        </div>
        <el-empty v-else :image-size="50" :description="$t('home.groupNoDevice')"></el-empty>
      </el-collapse-item>
    </div>

      <div v-if="newGroupList && newGroupList.length > 0">
      <el-collapse-item
          v-for="(item, index) in newGroupList"
          :key="index"
          :title="item.groupName"
          :name="index"
      >
        <div
            v-for="(it, idx) in item.deviceList.data"
            :key="idx"
            class="device-item p-3 d-flex align-items-center justify-content-between"
        >
          <div>{{ it.noteName }}</div>
          <div>
            <el-checkbox
                v-model="it.checked"
                size="large"
                @change="checkDevice"
            />
          </div>
        </div>
      </el-collapse-item>

    </div>


  </el-collapse>
</template>

<style scoped lang="scss">
.device-item {
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
